interface MapExpandToggleProps {
  expanded: boolean;
  onToggle: (expanded: boolean) => void;
}

/**
 * Expand / collapse control rendered directly under the map frame.
 */
export const MapExpandToggle = ({ expanded, onToggle }: MapExpandToggleProps) =>
  expanded ? (
    <button
      onClick={() => onToggle(false)}
      className="mt-2 mx-auto flex items-center gap-1.5 px-3 py-1.5 text-sm text-white bg-primary-700 hover:bg-primary-800 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-info-500"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L11 6.414V10H14a1 1 0 110 2h-3v3.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L9 15.586V12H6a1 1 0 110-2h3V6.414L7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3z" clipRule="evenodd" />
      </svg>
      Collapse Map
    </button>
  ) : (
    <button
      onClick={() => onToggle(true)}
      className="mt-2 mx-auto flex items-center gap-1.5 px-3 py-1.5 text-sm text-white bg-primary-700 hover:bg-primary-800 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-info-500"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
        <path d="M3 3a1 1 0 011-1h4a1 1 0 010 2H5.414l3.293 3.293a1 1 0 01-1.414 1.414L4 5.414V8a1 1 0 01-2 0V4a1 1 0 011-1zm14 14a1 1 0 01-1 1h-4a1 1 0 010-2h2.586l-3.293-3.293a1 1 0 011.414-1.414L16 14.586V12a1 1 0 012 0v4a1 1 0 01-1 1z" />
      </svg>
      Expand Map
    </button>
  );
